// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import customerReducer from './slices/customer';
import contactReducer from './slices/contact';
import productReducer from './slices/product';
import chatReducer from './slices/chat';
import calendarReducer from './slices/calendar';
import mailReducer from './slices/mail';
import userReducer from './slices/user';
import cartReducer from './slices/cart';
import kanbanReducer from './slices/kanban';
import menuReducer from './slices/menu';
import tipoReclamacaoReducer from './slices/tipoReclamacao';
import notificacaoReducer2 from './slices/notificacaoUsuarios2';
import denunciasReducer from './slices/denuncias';
import privilegiosReducer from './slices/privilegios';
import optionsReducer from './slices/options';
import VariablesMemoireReducer from './slices/VariablesMemoire';
import diversParametersReduxReducer from './slices/diversParametersRedux';

// Combine all reducers
const appReducer = combineReducers({
    snackbar: snackbarReducer,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'FUTURISS -'
        },
        cartReducer
    ),
    kanban: kanbanReducer,
    customer: customerReducer,
    contact: contactReducer,
    product: productReducer,
    chat: chatReducer,
    calendar: calendarReducer,
    mail: mailReducer,
    user: userReducer,
    menu: menuReducer,
    tipoReclamacao: tipoReclamacaoReducer,
    notificacaoUsuarios2: notificacaoReducer2,
    denuncias: denunciasReducer,
    privilegios: privilegiosReducer,
    options: optionsReducer,
    VariablesMemoire: VariablesMemoireReducer,
    diversParametersRedux: diversParametersReduxReducer
});

// Root reducer to handle global reset
const rootReducer = (state, action) => {
    if (action.type === 'RESET_STATE') {
        state = undefined; // Reset all state to initial values
    }
    return appReducer(state, action);
};

export default rootReducer;